export enum USER_ACCOUNT_LOADING_STATUS {
    IDLE = "idle",
    LOADING = "loading",
    READY = "ready",
}

export enum CLIENT_STATUS {
    FORM = "form",
    SUCCESS = "success",
    CODE = "code",
    ERROR = "error",
}

export enum LOGIN_ERROR {
    ClientAlreadyExists = "client_already_exists",
    ClientAlreadyAuthenticated = "client_already_authenticated",
    ClientNotFound = "client_not_found",
}

export enum CLIENT_AUTHORIZATION_PLACE {
    MAIN = "MAIN",
    MODAL = "MODAL",
}

export enum CLIENT_AUTHORIZATION_TEXT {
    MAIN = "Введите почту, чтобы войти или зарегистрироваться.",
    PAYMENT = "Для оплаты сессии войдите в\u00A0личный кабинет.",
    SURVEY = "Авторизуйтесь или зарегистрируйтесь, чтобы пройти анкету и\u00A0подобрать психолога.",
    BOOKING = "Для отмены или переноса сессии войдите в\u00A0личный кабинет.",
    PSYBOOKING = "Зарегистрируйтесь или войдите в\u00A0личный кабинет, чтобы записаться к\u00A0психологу.",
    FAVORITE = "Чтобы добавить психолога в\u00A0«Избранное», вам необходимо войти или зарегистрироваться.",
}

export const DEFAULT_ERROR_MESSAGE = <>Что-то пошло не&nbsp;так, попробуйте позже.</>
